export default __webpack_public_path__ + "static/media/icon-tel.722d79e4.svg";